import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import type { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import CardHeading from '../card-heading';
import ArrowCircleIcon from './arrow-circle-icon';
type AccountNotFoundProps = {
  onRequestDemo: () => void;
  onRetry: () => void;
  Title?: ElementType;
  Description?: ElementType;
};
const AccountNotFound = t0 => {
  const $ = _c(38);
  const {
    onRequestDemo,
    onRetry,
    Title,
    Description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "accountNotFound"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="fp-auth-overline mb-6 text-accent">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp3);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== Description || $[10] !== Title || $[11] !== t4 || $[12] !== t5) {
    t6 = <CardHeading Title={Title} Description={Description} title={t4} description={t5} />;
    $[9] = Description;
    $[10] = Title;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <div className="pr-10">{t3}{t6}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp4);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== onRequestDemo || $[20] !== t8) {
    t9 = <Button className="fp-auth-cta" size="large" suffixIcon={ArrowCircleIcon} onClick={onRequestDemo}>{t8}</Button>;
    $[19] = onRequestDemo;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t) {
    t10 = t(_temp5);
    $[22] = t;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== onRetry || $[25] !== t10) {
    t11 = <button type="button" className="fp-auth-link self-center cursor-pointer py-2 text-body-2 text-secondary hover:text-primary" onClick={onRetry}>{t10}</button>;
    $[24] = onRetry;
    $[25] = t10;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t9) {
    t12 = <div className="mt-6 flex flex-col gap-3 sm:flex-row">{t9}{t11}</div>;
    $[27] = t11;
    $[28] = t9;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t) {
    t13 = t(_temp6);
    $[30] = t;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t13) {
    t14 = <p className="fp-auth-rule mt-6 border-t pt-4 text-body-2 text-tertiary">{t13}</p>;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t7) {
    t15 = <div className="flex flex-col">{t7}{t12}{t14}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t7;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};
export default AccountNotFound;
function _temp($) {
  return $.overline;
}
function _temp2($_0) {
  return $_0.title;
}
function _temp3($_1) {
  return $_1.description;
}
function _temp4($_2) {
  return $_2.requestDemo;
}
function _temp5($_3) {
  return $_3.retry;
}
function _temp6($_4) {
  return $_4.invite;
}